import { useEffect, useState } from "react";
import { RefreshCw, X } from "lucide-react";
import { applyUpdate } from "../lib/pwa";

export const UpdatePrompt = () => {
    const [show, setShow] = useState(false);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        const on = () => setShow(true);
        window.addEventListener("pwa-update-available", on);
        return () => window.removeEventListener("pwa-update-available", on);
    }, []);

    if (!show) return null;
    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[60] bg-slate-900 text-white border-2 border-amber-500 shadow-2xl px-5 py-3 flex items-center gap-4 max-w-[92vw]" data-testid="update-prompt">
            <RefreshCw className={`w-4 h-4 text-amber-400 ${busy ? "animate-spin" : ""}`} />
            <div className="text-sm">
                <div className="font-semibold">Je dostupná nová verze</div>
                <div className="text-xs text-slate-400">Před aktualizací si uložte rozpracované údaje.</div>
            </div>
            <button onClick={() => { setBusy(true); applyUpdate(); }} data-testid="update-apply"
                    className="ml-2 bg-amber-500 hover:bg-amber-400 text-slate-900 px-4 py-1.5 text-xs font-bold uppercase tracking-wider rounded-sm">
                Aktualizovat
            </button>
            <button onClick={() => setShow(false)} className="text-slate-400 hover:text-white" title="Později"><X className="w-4 h-4" /></button>
        </div>
    );
};

export default UpdatePrompt;
